import toast from 'react-hot-toast';

export interface ConflictError {
  status: number;
  error: string;
}

export const handleConflictError = (
  error: any,
  actions?: any,
  fieldName?: string,
  //fieldMapping?: { [key: string]: string }
): boolean => {
  if (error.response?.status === 409) {
    const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.data;
    
    if (!errorMessage) {
      return false;
    }
    
    // if (error.config?.url?.includes('/brands/create')) {
    //   toast.error(errorMessage);
    //   return true;
    // }
    
    // if (actions && fieldMapping) {
    //   const fieldName = fieldMapping[errorMessage];
    //   if (fieldName) {
    //     actions.setFieldError(fieldName, errorMessage);
    //     return true;
    //   }
    // }

    if (actions && fieldName) {
      actions.setFieldError(fieldName, errorMessage);
      //return true;
    }

    toast.error(errorMessage);
    return true;
  }
  
  return false;
};

// export const getConflictFieldMapping = () => ({
//   'Project with this name already exists': 'project_name',
//   'Product with this name already exists': 'product_name',
//   'Brand with this name already exists': 'brand'
// });
